export { Flex } from "@mantine/core";
export type { FlexProps } from "@mantine/core";
